/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgPharmacy = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <path
        d="m15.19 5 1.936-3.486 1.748.972L17.477 5H21v4.75c0 3.2-1.583 6.03-4 7.692V20.8a1.2 1.2 0 0 1-1.2 1.2H8.2A1.2 1.2 0 0 1 7 20.8v-3.358C4.583 15.78 3 12.95 3 9.75V5zM9 18.473V20h6v-1.526a8.804 8.804 0 0 1-6 0zM5 7v2.75c0 2.697 1.42 5.04 3.512 6.288A6.802 6.802 0 0 0 12 17c1.27 0 2.46-.35 3.488-.963C17.58 14.79 19 12.448 19 9.75V7zm6 4V9h2v2h2v2h-2v2h-2v-2H9v-2z"
        fill="currentcolor"
      />
    </g>
  </Icon>
);
export { SvgPharmacy as Pharmacy };
